// Module
var code = "<div class=\"alert alert-info\" role=\"alert\" ng-show=\"vm.messages.length\"> <h4>{{'MESSAGE'|translate}}</h4> <p ng-repeat=\"message in vm.messages\"> <span ng-if=\"message.key\">{{ message.key | translate }}</span> <span ng-if=\"!message.key\">{{ message.message || message }}</span> </p> </div> ";
// Exports
module.exports = code;